import { Pipe, PipeTransform } from '@angular/core';

import { SingleDatePickerItem } from '../interfaces/single-date-picker-item.interface';

import { dateEqualsDateItem } from 'Angular/features/components/date-controls/single-date-picker/utils/single-date-picker-utils';

/**
 * Is Date Item Selected Pipe
 *
 * Checks if a given SingleDatePickerItem has the same year, month, and day as a selected date.
 */
@Pipe({
    name: 'isDateItemSelected',
    standalone: false,
})
export class isDateItemSelectedPipe implements PipeTransform {
    transform(dateItem: SingleDatePickerItem, selectedDate: Date | null): boolean {
        return !!selectedDate && dateEqualsDateItem(selectedDate, dateItem);
    }
}
